module.exports = __webpack_public_path__ + "img/1475404499.8f1a1cfc.jpg";